import { useEffect } from "react";
import "./home.css";
import Document from "../../components/Document/Document";
import Footer from "../../components/footer/footer";
import NavBar from "../../components/navbar/navbar";
import OurPartner from "../../components/OurPartner/OurPartner";
import OurTeam from "../../components/out-team/our-team";
import Pyracoin from "../../components/pyracoin/Pyracoin";
import Roadmap from "../../components/roadmap/roadmap";
import Values from "../../components/values/values";
import Features from "../../components/features/features";
import Section1 from "../../components/section-1/Section1";
import Tokennomics from "../../components/tokenomics/Tokennomics";
import Work from "../../components/work/work";



// Vishnu
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import Slide from 'react-reveal/Slide';


function HomeComponent() {
  return (
    <div className="App">
      <NavBar />
      <div className="section-wrapper">
        <Section1 />
      </div>
      <div id="img-back-app">
        <Tokennomics />
      </div>
      <div className="sect">
        <Values />
        <Pyracoin />
      </div>
      <div id="img-back-app2">
        <Zoom>
          <Features />
          {/* <Work /> */}
          <Roadmap />
        </Zoom>
      </div>

      <OurTeam />
      <Document />
      <Fade right>
        <OurPartner />
      </Fade>
      <Slide bottom>
        <Footer />
      </Slide>
    </div>
  );
}

export default HomeComponent;
